// extracted by mini-css-extract-plugin
module.exports = {"sectionContext":"_2UxhIx9fWF","form":"_2lqIsoyl68"};